import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Bibliography } from "../../types/bibliography";
import EntityTable from "../EntityTable";
import { extractBibliographyEditLink, extractBibliographyViewLink } from "../entitiesReferences/InternalEntityLink";
import { renderRowViewAndUpdateActions } from "../../common/TableUtils";
import { MRT_ColumnDef } from "material-react-table";
import useBibliographyQuery from "../../hooks/query/useBibliographyQuery";
import bibliographyColumns, {
  bibliographyFilterSpec,
} from "../../common/entities/BibliographyColumns";
import useServerFilters from "../../hooks/useServerFilters";

interface BibliographyTableProps {
  columns?: MRT_ColumnDef<Bibliography, any>[];
  filters?: Partial<Bibliography>;
  enableRowActions?: boolean;
}

const BibliographyTable: React.FC<BibliographyTableProps> = ({
  columns = bibliographyColumns,
  filters = {},
  enableRowActions = true,
}) => {
  const navigate = useNavigate();

  const {
    serverFilters,
    entityTableFilterProps,
    pagination,
    setPagination,
  } = useServerFilters(filters, bibliographyFilterSpec);
  const { useFetchAll } = useBibliographyQuery();
  const { data, isLoading, errorMessage } = useFetchAll({
    filters: serverFilters,
    externalPagination: pagination,
    externalSetPagination: setPagination,
  });

  const renderRowActions = useMemo(
    () =>
      renderRowViewAndUpdateActions(
        (bibliography: Bibliography) => navigate(extractBibliographyViewLink(bibliography)),
        (bibliography: Bibliography) => navigate(extractBibliographyEditLink(bibliography))
      ),
    [navigate]
  );

  return (
    <EntityTable
      loading={isLoading}
      error={errorMessage}
      columns={columns}
      renderRowActions={renderRowActions}
      enableRowActions={enableRowActions}
      enableRowSelection={false}
      data={data?.data || []}
      pagination={pagination}
      manualPagination={true}
      onPaginationChange={setPagination}
      totalRowCount={data?.total || 0}
      manualFiltering
      {...entityTableFilterProps}
    />
  );
};

export default BibliographyTable;

